import React from 'react';
import cn from 'classnames';

import classes from './Form.module.scss';

const SectionLabel = ({ className, label, required, margin }) => {
  return (
    <p
      className={cn(
        classes.sectionLabel,
        {
          [classes.marginSmall]: margin === 'small',
          [classes.marginMedium]: margin === 'medium',
          [classes.marginLarge]: margin === 'large',
        },
        className
      )}
    >
      {label || ''}
      {!!required && <span className={classes.requiredMark}>*</span>}
    </p>
  );
};

export default SectionLabel;
